import React from 'react';
import TimeZoneMismatchAlert from '@/components/partial/TimeZoneMismatchAlert';
import { useReserveForm } from '@/components/reserve/Reserve/ReserveFormProvider';

export interface ReserveFormTimeZoneMismatchAlertProps {
  onClose: () => void;
}

export const ReserveFormTimeZoneMismatchAlert: React.FC<
  ReserveFormTimeZoneMismatchAlertProps
> = ({ onClose }) => {
  const { isEmbedded, currentOfficeTz, currentOfficeId } = useReserveForm();
  return (
    <TimeZoneMismatchAlert
      embedded={isEmbedded}
      onClose={onClose}
      className="mb-5 max-w-xl"
      timezone={currentOfficeTz || ''}
      officeId={currentOfficeId}
    />
  );
};
